import React, { useEffect, useState } from 'react'
import query from 'jquery';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from "../contexts/AuthContext";
import { useCart } from "../contexts/CartContext";
import categoryService from "../services/categoryService";

const HeaderOne = () => {
    const { user, isAuthenticated, logout } = useAuth();
    const { getCartTotalItems, getCartTotalPrice } = useCart();
    const [scroll, setScroll] = useState(false)
    // Geri sayım state'i
    const [countdown, setCountdown] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });
    // Kategoriler için state
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    // Search input state
    const [searchQuery, setSearchQuery] = useState('')
    const navigate = useNavigate()

    useEffect(() => {
        window.onscroll = () => {
            if (window.pageYOffset < 150) {
                setScroll(false);
            } else if (window.pageYOffset > 150) {
                setScroll(true);
            }
            return () => (window.onscroll = null);
        };
        const selectElement = query('.js-example-basic-single');
        selectElement.select2();

        // Kategorileri getir
        const fetchCategories = async () => {
            try {
                setIsLoading(true);
                const response = await categoryService.getMainCategories();
                if (response.succeeded) {
                    // Kategorileri önce DisplayOrder'a göre, sonra isme göre sırala
                    const sortedCategories = [...response.categories].sort((a, b) => {
                        // Önce DisplayOrder'a göre sırala
                        if (a.displayOrder !== b.displayOrder) {
                            return a.displayOrder - b.displayOrder;
                        }
                        // DisplayOrder eşitse, isme göre sırala
                        return a.name.localeCompare(b.name, 'tr');
                    });
                    setCategories(sortedCategories);
                } else {
                    console.error("Kategoriler getirilemedi:", response.message);
                }
            } catch (error) {
                console.error("Kategori yükleme hatası:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchCategories();

        // Geri sayım için hedef tarih - örneğin 7 gün sonrası
        const targetDate = new Date();
        targetDate.setDate(targetDate.getDate() + 7);

        // Geri sayım için interval oluştur
        const countdownInterval = setInterval(() => {
            const now = new Date().getTime();
            const distance = targetDate.getTime() - now;

            // Geri sayım değerlerini hesapla
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            setCountdown({ days, hours, minutes, seconds });

            // Geri sayım bittiğinde interval'i temizle
            if (distance < 0) {
                clearInterval(countdownInterval);
                setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        }, 1000);

        return () => {
            if (selectElement.data('select2')) {
                selectElement.select2('destroy');
            }
            clearInterval(countdownInterval);
        };

    }, []);

    // Set the default language
    const [selectedLanguage, setSelectedLanguage] = useState("Eng");
    const handleLanguageChange = (language) => {
        setSelectedLanguage(language);
    };

    // Set the default currency
    const [selectedCurrency, setSelectedCurrency] = useState("USD");
    const handleCurrencyChange = (currency) => {
        setSelectedCurrency(currency);
    };


    // Mobile menu support
    const [menuActive, setMenuActive] = useState(false)
    const [activeIndex, setActiveIndex] = useState(null);
    const handleMenuClick = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };
    const handleMenuToggle = () => {
        setMenuActive(!menuActive);
    };


    // Search control support
    const [activeSearch, setActiveSearch] = useState(false)
    const handleSearchToggle = () => {
        setActiveSearch(!activeSearch);
    };

    // category control support
    const [activeCategory, setActiveCategory] = useState(false)
    const handleCategoryToggle = () => {
        setActiveCategory(!activeCategory);
    };
    const [activeIndexCat, setActiveIndexCat] = useState(null);
    const handleCatClick = (index) => {
        setActiveIndexCat(activeIndexCat === index ? null : index);
    };

    // Handle search form submissions
    const handleSearchSubmit = (e) => {
        e.preventDefault()
        const query = searchQuery.trim()
        if (query) navigate(`/shop?searchTerm=${encodeURIComponent(query)}`)
        else navigate('/shop')
        setActiveSearch(false)
        setSearchQuery('')
    }

    // Logout handler
    const handleLogout = async () => {
        try {
            console.log("Çıkış yapılıyor...");
            const result = await logout();
            console.log("Çıkış sonucu:", result);
            
            // Sayfayı yenile ve anasayfaya yönlendir
            window.location.href = "/";
        } catch (error) {
            console.error("Çıkış yapılırken hata oluştu:", error);
            // Hata olsa bile localStorage'ı temizle ve anasayfaya yönlendir
            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("user");
            window.location.href = "/";
        }
    };

    return (
        <>
            <div className="overlay" />
            <div className={`side-overlay ${(menuActive || activeCategory) && "show"}`} />
            {/* ==================== Search Box Start Here ==================== */}
            <form onSubmit={handleSearchSubmit} className={`search-box ${activeSearch && "active"}`}>
                <button onClick={handleSearchToggle}
                    type="button"
                    className="search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-white text-2xl transition-1"
                >
                    <i className="ph ph-x" />
                </button>
                <div className="container">
                    <div className="position-relative">
                        <input
                            type="text"
                            className="form-control py-16 px-24 text-xl rounded-pill pe-64"
                            placeholder="Ürün ya da marka ara"
                            value={searchQuery}
                            onChange={e => setSearchQuery(e.target.value)}
                        />
                        <button
                            type="submit"
                            className="w-48 h-48 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
                        >
                            <i className="ph ph-magnifying-glass" />
                        </button>
                    </div>
                </div>
            </form>
            {/* ==================== Search Box End Here ==================== */}
            {/* ==================== Mobile Menu Start Here ==================== */}
            <div className={`mobile-menu scroll-sm d-lg-none d-block ${menuActive && "active"}`}>
                <button onClick={() => { handleMenuToggle(); setActiveIndex(null) }} type="button" className="close-button">

                    <i className="ph ph-x" />{" "}
                </button>
                <div className="mobile-menu__inner">
                    <Link to="/" className="mobile-menu__logo">
                        <img src="/assets/images/logo/logo.png" alt="Logo" />
                    </Link>
                    <div className="mobile-menu__menu">
                        {/* Nav Menu Start */}
                        <ul className="nav-menu flex-align nav-menu--mobile">
                            <li className="nav-menu__item">
                                <Link to="/" className="nav-menu__link" onClick={() => setMenuActive(false)}>Anasayfa</Link>
                            </li>
                            <li className="nav-menu__item">
                                <Link to="/shop" className="nav-menu__link" onClick={() => setMenuActive(false)}>Tüm Ürünler</Link>
                            </li>
                            <li className="nav-menu__item">
                                <Link to="/kendin-sec" className="nav-menu__link" onClick={() => setMenuActive(false)}>Kendi paketini oluştur</Link>
                            </li>
                        </ul>
                        {/* Nav Menu End */}
                    </div>
                </div>
            </div>
            {/* ==================== Mobile Menu End Here ==================== */}
            {/* ======================= Middle Top Start ========================= */}
            <div className="header-top bg-main-600 flex-between">
                <div className="container container-lg">
                    <div className="flex-between flex-wrap gap-8 py-8">
                        <ul className="flex-align flex-wrap d-none d-md-flex">
                            <li className="border-right-item">
                                <Link
                                    to="/profile"
                                    className="text-white text-sm hover-text-decoration-underline"
                                >
                                    Hesabım
                                </Link>
                            </li>
                            <li className="border-right-item">
                                <Link
                                    to="/sozlesme"
                                    className="text-white text-sm hover-text-decoration-underline"
                                >
                                    Sözleşmeler
                                </Link>
                            </li>
                            <li className="border-right-item">
                                <Link
                                    to="/iade-politikasi"
                                    className="text-white text-sm hover-text-decoration-underline"
                                >
                                    İade Politikası
                                </Link>
                            </li>
                        </ul>
                        <ul className="header-top__right flex-align flex-wrap">
                            <li className="border-right-item">
                                <div className="text-white text-sm py-8 flex-align gap-6">
                                    <span className="icon text-md d-flex">
                                        <i className="ph ph-truck" />
                                    </span>
                                    <span>
                                        10kg üzeri siparişlerde ücretsiz kargo
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {/* ======================= Middle Top End ========================= */}
            {/* ======================= Middle Header Start ========================= */}
            <header className="header-middle bg-color-one border-bottom border-gray-100">
                <div className="container container-lg">
                    <nav className="header-inner flex-between">
                        {/* Logo Start */}
                        <div className="logo" style={{ maxWidth: "120px" }}>
                            <Link to="/" className="link">
                                <img src="/assets/images/logo/logo.png" alt="Logo" />
                            </Link>
                        </div>
                        {/* Logo End  */}
                        {/* Header Middle Search Start */}
                        <form onSubmit={handleSearchSubmit} className="flex-align flex-wrap form-location-wrapper">
                            <div className="search-form d-sm-flex d-none">
                                <div className="search-form__wrapper position-relative">
                                    <input
                                        type="text"
                                        className="search-form__input common-input py-13 ps-16 pe-18 rounded-pill pe-44"
                                        placeholder="Ürün ya da marka ara"
                                        style={{ width: "500px" }}
                                        value={searchQuery}
                                        onChange={e => setSearchQuery(e.target.value)}
                                    />
                                    <button type="submit" className="w-32 h-32 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8">
                                        <i className="ph ph-magnifying-glass" />
                                    </button>
                                </div>
                            </div>
                        </form>
                        {/* Header Middle Search End */}
                        {/* Header Middle Right start */}
                        <div className="header-right flex-align d-lg-block d-none">
                            <div className="flex-align flex-wrap gap-12">
                                <button
                                    type="button"
                                    className="search-icon flex-align d-lg-none d-flex gap-4"
                                >
                                    <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                                        <i className="ph ph-magnifying-glass" />
                                    </span>
                                </button>
                                <div className="on-hover-item flex-align gap-4 item-hover">
                                    {isAuthenticated() ? (
                                        <Link to="/profile" className="flex-align gap-4 item-hover">
                                            <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                                                <i className="ph ph-user-circle" />
                                            </span>
                                            <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                                                {user?.firstName || 'Hesabım'} <i className="ph ph-caret-down" style={{ marginLeft: '4px' }}></i>
                                            </span>
                                        </Link>
                                    ) : (
                                        <Link to="/login" className="flex-align gap-4 item-hover">
                                            <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                                                <i className="ph ph-user-circle" />
                                            </span>
                                            <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                                                Giriş Yap <i className="ph ph-caret-down" style={{ marginLeft: '4px' }}></i>
                                            </span>
                                        </Link>
                                    )}
                                    <div className="on-hover-dropdown common-dropdown p-0 mt-2">
                                        {isAuthenticated() ? (
                                            <ul className="p-0 py-8 w-100">
                                                <li className="common-dropdown__item">
                                                    <Link to="/profile" className="common-dropdown__link hover-bg-neutral-100 px-16 py-8 flex-align gap-8">
                                                        <span className="text-md d-flex">
                                                            <i className="ph ph-user" />
                                                        </span>
                                                        <span>Profilim</span>
                                                    </Link>
                                                </li>
                                                <li className="common-dropdown__item">
                                                    <Link to="/addresses" className="common-dropdown__link hover-bg-neutral-100 px-16 py-8 flex-align gap-8">
                                                        <span className="text-md d-flex">
                                                            <i className="ph ph-map-pin" />
                                                        </span>
                                                        <span>Adres Bilgilerim</span>
                                                    </Link>
                                                </li>
                                                <li className="common-dropdown__item">
                                                    <Link to="/orders" className="common-dropdown__link hover-bg-neutral-100 px-16 py-8 flex-align gap-8">
                                                        <span className="text-md d-flex">
                                                            <i className="ph ph-shopping-bag" />
                                                        </span>
                                                        <span>Siparişlerim</span>
                                                    </Link>
                                                </li>
                                                <li className="common-dropdown__item">
                                                    <button 
                                                        onClick={handleLogout}
                                                        className="common-dropdown__link hover-bg-neutral-100 px-16 py-8 flex-align gap-8 w-100 text-start border-0 bg-transparent"
                                                    >
                                                        <span className="text-md d-flex">
                                                            <i className="ph ph-sign-out" />
                                                        </span>
                                                        <span>Çıkış Yap</span>
                                                    </button>
                                                </li>
                                            </ul>
                                        ) : (
                                            <ul className="p-0 py-8 w-100">
                                                <li className="common-dropdown__item">
                                                    <Link to="/login" className="common-dropdown__link hover-bg-neutral-100 px-16 py-8 flex-align gap-8">
                                                        <span className="text-md d-flex">
                                                            <i className="ph ph-sign-in" />
                                                        </span>
                                                        <span>Giriş Yap</span>
                                                    </Link>
                                                </li>
                                                <li className="common-dropdown__item">
                                                    <Link to="/register" className="common-dropdown__link hover-bg-neutral-100 px-16 py-8 flex-align gap-8">
                                                        <span className="text-md d-flex">
                                                            <i className="ph ph-user-plus" />
                                                        </span>
                                                        <span>Kayıt Ol</span>
                                                    </Link>
                                                </li>
                                            </ul>
                                        )}
                                    </div>
                                </div>
                                <Link to="/cart" className="flex-align gap-4 item-hover">
                                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                                        <i className="ph ph-shopping-cart-simple" />
                                        <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                                            {getCartTotalItems()}
                                        </span>
                                    </span>
                                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                                        Sepet ({getCartTotalPrice().toFixed(2)} ₺)
                                    </span>
                                </Link>
                            </div>
                        </div>
                        {/* Header Middle Right End  */}
                    </nav>
                </div>
            </header>
            {/* ======================= Middle Header End ========================= */}
            {/* ==================== Header Start Here ==================== */}
            <header className={`header bg-white border-bottom border-gray-100 ${scroll && "fixed-header"}`}>
                <div className="container container-lg">
                    <nav className="header-inner d-flex justify-content-between gap-8">
                        <div className="flex-align menu-category-wrapper">
                            {/* Category Dropdown Start */}
                            <div className="category on-hover-item">
                                <button
                                    onClick={handleCategoryToggle}
                                    type="button"
                                    className="category__button flex-align gap-8 fw-medium p-16 border-end border-start border-gray-100 text-heading"
                                >
                                    <span className="icon text-2xl d-xs-flex d-none">
                                        <i className="ph ph-dots-nine" />
                                    </span>
                                    <span className="d-sm-flex d-none">Tüm</span> Kategoriler
                                    <span className="arrow-icon text-xl d-flex">
                                        <i className="ph ph-caret-down" />
                                    </span>
                                </button>
                                <div className={`responsive-dropdown cat on-hover-dropdown common-dropdown nav-submenu p-0 submenus-submenu-wrapper ${activeCategory && "active"}`}>
                                    <button
                                        onClick={() => { handleCategoryToggle(); setActiveIndexCat(null) }}
                                        type="button"
                                        className="close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex"
                                    >
                                        {" "}
                                        <i className="ph ph-x" />{" "}
                                    </button>
                                    {/* Logo Start */}
                                    <div className="logo px-16 d-lg-none d-block">
                                        <Link to="/" className="link">
                                            <img src="/assets/images/logo/logo.png" alt="Logo" />
                                        </Link>
                                    </div>
                                    {/* Logo End */}
                                    <ul className="scroll-sm p-0 py-8 w-300 max-h-400 overflow-y-auto">
                                        {isLoading ? (
                                            <li className="text-center py-12 px-16">
                                                <span>Kategoriler yükleniyor...</span>
                                            </li>
                                        ) : categories.length > 0 ? (
                                            categories.map((category, index) => (
                                                <li key={category.id} onClick={() => handleCatClick(index)} className={`has-submenus-submenu ${activeIndexCat === index ? "active" : ""}`}>
                                                    <Link
                                                        to="#"
                                                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                                                    >
                                                        <span className="text-xl d-flex">
                                                            <i className="ph ph-folder" />
                                                        </span>
                                                        <span>{category.name}</span>
                                                        <span className="icon text-md d-flex ms-auto">
                                                            <i className="ph ph-caret-right" />
                                                        </span>
                                                    </Link>
                                                    <div className={`submenus-submenu py-16 ${activeIndexCat === index ? "open" : ""}`}>
                                                        <h6 className="text-lg px-16 submenus-submenu__title">
                                                            {category.name}
                                                        </h6>
                                                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                                                            {category.subCategories && category.subCategories.length > 0 ? (
                                                                category.subCategories.map(subCat => (
                                                                    <li key={subCat.id}>
                                                                        <Link to={`/shop?category=${subCat.id}`}>{subCat.name}</Link>
                                                                    </li>
                                                                ))
                                                            ) : (
                                                                <li>
                                                                    <Link to={`/shop?category=${category.id}`}>Tüm {category.name}</Link>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="text-center py-12 px-16">
                                                <span>Kategori bulunamadı.</span>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                            {/* Category Dropdown End  */}
                            {/* Menu Start  */}
                            <div className="header-menu d-lg-block d-none">
                                {/* Nav Menu Start */}
                                <ul className="nav-menu flex-align ">
                                    <li className="nav-menu__item">
                                        <NavLink to="/" className={(navData) => navData.isActive ? "nav-menu__link activePage" : "nav-menu__link"}>Anasayfa</NavLink>
                                    </li>
                                    <li className="nav-menu__item">
                                        <NavLink to="/shop" className={(navData) => navData.isActive ? "nav-menu__link activePage" : "nav-menu__link"}>Tüm Ürünler</NavLink>
                                    </li>
                                    <li className="nav-menu__item">
                                        <NavLink to="/kendin-sec" className={(navData) => navData.isActive ? "nav-menu__link activePage" : "nav-menu__link"}>Kendi paketini oluştur</NavLink>
                                    </li>
                                </ul>
                                {/* Nav Menu End */}
                            </div>
                            {/* Menu End  */}
                        </div>
                        {/* Header Right start */}
                        <div className="header-right flex-align">
                            <a
                                href="https://wa.me/905394838998"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex d-none"
                            >
                                <div className="d-flex text-32">
                                    <i className="ph-fill ph-whatsapp-logo" />
                                </div>
                                539 483 89 98
                            </a>
                            <div className="me-16 d-lg-none d-block">
                                <div className="flex-align flex-wrap gap-12">
                                    <button onClick={handleSearchToggle} type="button" className="search-icon flex-align d-lg-none d-flex gap-4 item-hover">
                                        <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                                            <i className="ph ph-magnifying-glass" />
                                        </span>
                                    </button>
                                    <Link to="/cart" className="flex-align gap-4 item-hover">
                                        <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                                            <i className="ph ph-shopping-cart-simple" />
                                            <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                                                {getCartTotalItems()}
                                            </span>
                                        </span>
                                        <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                                            Sepet ({getCartTotalPrice().toFixed(2)} ₺)
                                        </span>
                                    </Link>
                                </div>
                            </div>
                            <button
                                onClick={handleMenuToggle}
                                type="button"
                                className="toggle-mobileMenu d-lg-none ms-3n text-gray-800 text-4xl d-flex"
                            >
                                {" "}
                                <i className="ph ph-list" />{" "}
                            </button>
                        </div>
                        {/* Header Right End  */}
                    </nav>
                </div>
            </header>
            {/* ==================== Header End Here ==================== */}
        </>

    )
}

export default HeaderOne